import { Typography } from '@mui/material'
import styles from './signup.module.scss'
import { auth } from '../../features/authSlice.js'
import ButtonCustom from '../atoms/button/ButtonCustom.jsx'
import InputCustom from '../atoms/input/InputCustom.jsx'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { LoadingSpinner } from '../loadingSpinner/LoadingSpinner.jsx'
import { validatePassword } from '../../util/passwordValidation.js'

const initialFormData = {
	email: '',
	password: '',
	confirmPassword: '',
}
const SignUpForm = () => {
	const dispatch = useDispatch()
	const [passwordError, setPasswordError] = useState('')
	const [formData, setFormData] = useState(initialFormData)
	const [confirmPasswordError, setConfirmPasswordError] = useState('')
	const role = useSelector((state) => state.auth.role)
	const loading = useSelector((state) => state.auth.loading)

	const handleGoogleLogin = () => {
		const client = window.google.accounts.oauth2.initCodeClient({
			client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
			redirect_uri: `${window.location.origin}/google-redirect`,
			scope: 'email profile',
			state: 'register',
			ux_mode: 'redirect',
		})
		client.requestCode()
	}

	const handleSubmit = (e) => {
		e.preventDefault()
		const error = validatePassword(formData.password)
		if (error) return setPasswordError(error)
		if (formData.password !== formData.confirmPassword)
			return setConfirmPasswordError('Passwords do not match')
		dispatch(auth({ ...formData, mode: 'register', role }))
	}
	return (
		<form className={styles.form} onSubmit={handleSubmit}>
			<div className={styles.formGroup}>
				<InputCustom
					data-cy="email"
					placeholder="Email"
					name="email"
					type="email"
					value={formData.email}
					autoFocus={true}
					setDataFunction={setFormData}
					data={formData}
					required={true}
				/>
			</div>
			<div className={styles.formGroup}>
				<InputCustom
					data-cy="password"
					placeholder="Password"
					name="password"
					type="password"
					enableShowPassword={true}
					value={formData.password}
					setDataFunction={setFormData}
					data={formData}
					required={true}
					eyeIcon={true}
					error={!!passwordError}
					changeFunction={() => {
						setPasswordError('')
						setConfirmPasswordError('')
					}}
				/>
				{passwordError && <p className="text-error">{passwordError}</p>}
			</div>

			<div className={styles.formGroup}>
				<InputCustom
					data-cy="confirmPassword"
					placeholder="Confirm Password"
					name="confirmPassword"
					type="password"
					enableShowPassword={true}
					value={formData.confirmPassword}
					setDataFunction={setFormData}
					data={formData}
					required={true}
					eyeIcon={true}
					error={!!confirmPasswordError}
					changeFunction={() => setConfirmPasswordError('')}
				/>
				{confirmPasswordError && (
					<p className="text-error">{confirmPasswordError}</p>
				)}
			</div>

			<div className={styles.signUpBtn}>
				<ButtonCustom variant="default" type="submit">
					{loading ? (
						<LoadingSpinner size="10px" color="#333" />
					) : (
						'Sign Up'
					)}
				</ButtonCustom>
			</div>
			<div className={styles.or}>
				<Typography>or</Typography>
			</div>
			<div className={styles.socialLoginBtns}>
				<ButtonCustom variant="outlined" onClick={handleGoogleLogin}>
					<img src="/images/google-icon.svg" />
					<Typography variant="body">Continue with Google</Typography>
				</ButtonCustom>
				{/* <FacebookLoginButton /> */}
			</div>
		</form>
	)
}

export default SignUpForm
